import React, { ReactChild } from 'react';
import styled from 'styled-components/macro';

import Box from 'components/elements/Box';
import Span from 'components/elements/span';
import TippyToolTip from 'components/base/TippyToolTip/TippyToolTip';

import { ReactComponent as IconMagicWand } from 'icons/customize-view.svg';

import colors from 'styles/themes/colors';

export const CustomizeButton = styled('button')<{ isActive?: boolean }>`
  display: flex;
  align-items: center;
  margin-right: 1rem;
  padding: 0 1rem;
  border: 1px solid
    ${({ isActive, theme }): string =>
      isActive ? theme.AccentGreen : '#E9EBED'};
  cursor: pointer;
  border-radius: 4px;
  color: ${({ isActive, theme }): string =>
    isActive ? theme.AccentGreen : theme.ShadowBlack};

  &:hover {
    border-color: #0bd6a7;
    background: #f7f7f7;
  }

  & > svg path {
    fill: ${({ isActive, theme }): string =>
      isActive ? theme.AccentGreen : theme.ShadowBlack};
  }
`;

const CustomizeBox = styled(Box)`
  margin-right: 1rem;
  border-radius: 4px;

  &:hover {
    border-color: #0bd6a7;
    background: #f7f7f7;
  }
`;

export const IconBox = styled(Box)<{ isActive: boolean }>`
  padding: 0.75rem;
  display: flex;
  align-items: center;

  & > svg path {
    fill: ${({ isActive, theme }): string =>
      isActive ? theme.AccentGreen : theme.ShadowBlack};
  }
`;

const noop = (): void => {}; // eslint-disable-line @typescript-eslint/no-empty-function

const CustomizedViewButton: React.FC<{
  isShownCustomizeButton?: boolean;
  isSmallScreen?: boolean;
  customizedMode?: {
    onClick: () => void;
    customizeButtonText: string;
    isCustomizedActive: boolean;
  };
  childred?: ReactChild | JSX.Element;
}> = ({ isSmallScreen, customizedMode, children }: any) => {
  return (
    <Box display="flex">
      {customizedMode?.isShownCustomizeButton && (
        <>
          {isSmallScreen ? (
            <CustomizeBox
              border={`1px solid ${
                customizedMode?.isCustomizedActive
                  ? colors?.AccentGreen
                  : '#E9EBED'
              }`}
              onClick={customizedMode?.onClick || noop}
            >
              <TippyToolTip
                tooltipContent={customizedMode?.customizeButtonText}
                enabled
                isAligned
              >
                <IconBox
                  padding="0.75rem"
                  display="flex"
                  alignItems="center"
                  isActive={customizedMode?.isCustomizedActive}
                >
                  <IconMagicWand />
                </IconBox>
              </TippyToolTip>
            </CustomizeBox>
          ) : (
            <CustomizeButton
              type="button"
              isActive={customizedMode?.isCustomizedActive}
              onClick={customizedMode?.onClick || noop}
            >
              <IconMagicWand />
              <Span
                fontSize="1rem"
                fontFamily="Proxima Nova"
                marginLeft="0.625rem"
                fontWeight="600"
              >
                {customizedMode?.customizeButtonText}
              </Span>
            </CustomizeButton>
          )}
        </>
      )}
      {children}
    </Box>
  );
};

export default CustomizedViewButton;
